// @ts-check
import { settingsValues } from './settingsValues';

/**
 * @template {import('./configsSettings').SettingsKeys} K
 * @param {K} name
 * @returns {import('./settingsValues').SettingsValues[K]}
 */
export function useSettingRef(name) {
  if (!Object.hasOwn(settingsValues, name)) {
    throw new Error(`Local setting '${name}' is not registered`);
  }

  return settingsValues[name];
}
